import React, { useMemo } from 'react';
import Avatar from '@atlaskit/avatar';
import ProfileCardTrigger from '@atlaskit/profilecard/user';
import { AvatarSkeleton, AvatarWrapper } from '../../avatar-layout';
import { useProfileClient } from '../../use-profile-client';
function AvatarContainer(_ref) {
  var actors = _ref.actors;
  var userId = useMemo(function () {
    var _actors$;
    return (_actors$ = actors[0]) === null || _actors$ === void 0 || (_actors$ = _actors$.ari) === null || _actors$ === void 0 ? void 0 : _actors$.split('/')[1];
  }, [actors]);
  var profileClient = useProfileClient();
  if (!actors.length) {
    return /*#__PURE__*/React.createElement(AvatarSkeleton, null);
  }
  var avatar = /*#__PURE__*/React.createElement(Avatar, {
    name: actors[0].displayName,
    appearance: "circle",
    src: actors[0].avatarUrl,
    size: "large"
  });
  return /*#__PURE__*/React.createElement(AvatarWrapper, {
    "data-testid": "avatar-wrapper"
  }, userId ? /*#__PURE__*/React.createElement(ProfileCardTrigger, {
    trigger: "hover",
    userId: userId,
    resourceClient: profileClient,
    testId: "profile-card-trigger"
  }, avatar) : avatar);
}
export default AvatarContainer;